export default {"src":"/_next/static/media/views.5a8b40cf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};